import apiClient from '../api/apiClient';
import { enable_mock_cmr_extraction } from '../api/baseUrls';

const CMR_EXTRACTION_PATH = '/api/v1/utility/cmr/extraction';
const EXTRACTION_TIMEOUT_MS = 900000;

const MOCK_DELAY_MIN_MS = 1500;
const MOCK_DELAY_MAX_MS = 3000;

export const MOCK_CMR_EXTRACTION_DATA = {
  pan: 'AOMPT8456N',
  email: 'tripathilokpati@outlook.com',
  mobile: '9768162389',
  demat_account: '1208160002672300',
  dob: '15-MAR-1993',
  bank_account: '50100166636989',
  bank_name: 'HDFC BANK LTD',
  ifsc: 'HDFC0000543',
};

const multipartConfig = {
  timeout: EXTRACTION_TIMEOUT_MS,
  headers: {
    'Content-Type': false,
    Accept: 'application/json',
  },
};

function unwrapExtractionPayload(payload) {
  if (payload?.data && typeof payload.data === 'object') {
    return payload.data;
  }
  return payload ?? {};
}

export function normalizeCmrExtractionResult(extraction) {
  if (!extraction || typeof extraction !== 'object') return {};

  const trim = (val) => {
    const s = String(val ?? '').trim();
    if (!s || s.toLowerCase() === 'null' || s.toLowerCase() === 'undefined') return '';
    return s;
  };

  const mobileDigits = String(extraction.mobile ?? '').replace(/\D/g, '');
  const mobile =
    mobileDigits.length === 10
      ? mobileDigits
      : mobileDigits.length > 10
        ? mobileDigits.slice(-10)
        : '';

  const result = {
    pan: trim(extraction.pan).toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 10),
    email: trim(extraction.email),
    mobile,
    demat_account: trim(extraction.demat_account),
    dob: trim(extraction.dob),
    bank_account: trim(extraction.bank_account),
    bank_name: trim(extraction.bank_name),
    ifsc: trim(extraction.ifsc).toUpperCase(),
  };

  if (extraction._upload_file_name) {
    result._upload_file_name = trim(extraction._upload_file_name);
  }

  return result;
}

async function extractCmrFromFileLive(file) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await apiClient.request({
    method: 'POST',
    url: CMR_EXTRACTION_PATH,
    data: formData,
    ...multipartConfig,
  });

  return normalizeCmrExtractionResult(unwrapExtractionPayload(response.data));
}

async function extractCmrFromFileMock(file) {
  const waitMs =
    MOCK_DELAY_MIN_MS +
    Math.floor(Math.random() * (MOCK_DELAY_MAX_MS - MOCK_DELAY_MIN_MS + 1));
  const startedAt = Date.now();

  extractCmrFromFileLive(file).catch(() => {});

  const elapsed = Date.now() - startedAt;
  if (elapsed < waitMs) {
    await new Promise((r) => setTimeout(r, waitMs - elapsed));
  }

  return normalizeCmrExtractionResult(MOCK_CMR_EXTRACTION_DATA);
}

export async function extractCmrFromFile(file) {
  if (enable_mock_cmr_extraction) {
    return extractCmrFromFileMock(file);
  }
  return extractCmrFromFileLive(file);
}

export default {
  extractCmrFromFile,
  normalizeCmrExtractionResult,
  MOCK_CMR_EXTRACTION_DATA,
};
